import { mapState } from 'vuex'
import { getShortId, numberWithSeparator } from '@/utils/format-strings'
import copyTextMixin from '@/components/mixins/copy-text-mixin'

export default {
  name: 'PaymentGroupOrderDishes',
  /**   * 
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [copyTextMixin],
  props: {
    groups: {
      type: Array,
      default: () => []
    },

    notAccepted: {
      type: Boolean,
      default: false
    },

    isCancel: {
      type: Boolean,
      default: false
    }
  },

  computed: {

    ...mapState({
      paymentTypes: state => state.sharedData.paymentTypes
    })
  },

  methods: {
    getShortId,
    numberWithSeparator,

    getOrderId(order) {
      if (typeof order === 'object') {
        return order.id
      }
      return order
    }
  }
}